import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiZap } = FiIcons;

/**
 * ChangelogBadge
 * Shows for ALL severity levels (low/medium/high).
 * For 'low' deploys this is the ONLY UI indicator — no toast, no modal.
 * Disappears once the user opens the changelog modal (hasNewUpdate → false).
 */
const ChangelogBadge = ({ hasNewUpdate, onClick, className = '' }) => (
  <AnimatePresence>
    {hasNewUpdate && (
      <motion.button
        initial={{ opacity: 0, scale: 0.7 }}
        animate={{ opacity: 1, scale: 1   }}
        exit={{   opacity: 0, scale: 0.7  }}
        onClick={onClick}
        title="New platform update — click to see what changed"
        className={`relative flex items-center gap-1.5 px-3 py-1.5 rounded-xl border border-brand-pink/30 bg-brand-pink/10 text-brand-pink text-[9px] font-black uppercase tracking-widest hover:bg-brand-pink/20 transition-all ${className}`}
      >
        {/* Pulse ring — draws the eye without interrupting */}
        <span className="absolute inset-0 rounded-xl border border-brand-pink/40 animate-ping opacity-30 pointer-events-none" />
        <SafeIcon icon={FiZap} className="text-[10px]" />
        What's New
      </motion.button>
    )}
  </AnimatePresence>
);

export default ChangelogBadge;